/**
 * Base URL embedded in Supabase auth emails (reset password, verify email).
 * Set REACT_APP_AUTH_SITE_URL=https://devellotech.ca in .env so "Forgot password"
 * still sends links to production when you trigger it from localhost.
 * That URL must appear under Supabase → Authentication → URL Configuration → Redirect URLs.
 */
export function getAuthSiteUrl() {
  const fromEnv = (process.env.REACT_APP_AUTH_SITE_URL || '').trim().replace(/\/$/, '');
  if (fromEnv) return fromEnv;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/$/, '');
  }
  return 'https://devellotech.ca';
}
